import { useHookstate } from "@hookstate/core";
import { getClubMeta, updateLocalStateRaw } from "../../../misc/utils";
import { clubTabs } from "../../../misc/constants";
import Club from "./Club";
import { Categories } from "../../../components/Categories";
import { useUniversalFindAll } from "../../../hooks/universal";

export const ClubPage = ({ clubTypeName }: { clubTypeName: string }) => {
  const clubTypes: any[] = useUniversalFindAll("ClubType");
  const foundClubType = clubTypes.find((t) => t.name === clubTypeName);
  const clubMeta = getClubMeta(clubTypeName);
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const currentTab = state.currentTab || "list";

  const updateTab = (key: string) => () => {
    updateLocalStateRaw(localState, "currentTab")(key);
  };

  return (
    <div className='flex flex-col gap-4 bg-[#F0F3FA80] w-full h-full p-8'>
      <div className='flex flex-row self-start bg-white rounded-xl p-2 gap-3'>
        {clubTabs.map((t) => {
          const isActive = currentTab === t.key;
          const Icon = t.icon;
          return (
            <div
              key={t.key}
              className={`flex flex-row ${
                isActive && "bg-valley-main"
              } gap-[6px] px-2 py-1.5 items-center rounded-lg cursor-pointer`}
              onClick={updateTab(t.key)}
            >
              <Icon
                additionalStyle={isActive ? "text-white" : "text-valley-main"}
              />
              <span
                className={`font-medium leading-[19.2px] ${
                  isActive ? "text-white" : "text-valley-black"
                }`}
              >
                {t.label || clubMeta.leftTabText}
              </span>
            </div>
          );
        })}
      </div>
      {currentTab === "list" && <Club clubType={foundClubType} />}
      {currentTab === "categories" && (
        <Categories clubType={foundClubType} model='ClubCategory' />
      )}
    </div>
  );
};
